import { z } from 'my-zod'
import { outfitterWaiverContentModel } from './outfitter-waiver-content-model'

export const outfitterWaiverContentSystemView = outfitterWaiverContentModel
export type outfitterWaiverContentSystemView = z.infer<typeof outfitterWaiverContentSystemView>
